<template>
  <Teleport to="body">
    <PvDialog id="alert" v-model:visible="isVisible" modal :closable="false" style="min-width: 400px" >
      <template #container>
        <div class="d-flex flex-column text-center align-items-center p-4 rounded">
          <div class="headless-circle d-flex-inline justify-content-center align-items-center">
            <i :class="ALERT_ICONS[alertType]" :style="{ color: ALERT_COLORS[alertType], fontSize: '3rem' }"></i>
          </div>
          <!-- Header -->
          <span class="fw-bold fs-2 mb-2 mt-5">{{ header }}</span>
          <!-- Message -->
          <p class="mb-0 mt-3 text-center">{{ message }}</p>
          <div class="d-flex align-items-center gap-2 mt-5">
            <PvButton ref="alertButton" rounded raised class="action-btn" label="OK" size="small" @click="hideAlert" />
          </div>
        </div>
      </template>    
    </PvDialog>
  </Teleport>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core


// Components


// Composables
import { storeToRefs } from 'pinia';

// Stores
import { useAlertStore } from '@/stores/alertStore';

// Constants and Utils
import { ICONS, ALERT_TYPES } from '@/utils/constants';

// ===============================
// COMPOSABLES & STORES
// ===============================
const alertStore = useAlertStore();
const { isVisible, message, header, alertType } = storeToRefs(alertStore);

// ===============================
// CONSTANTS
// ===============================
const ALERT_ICONS = {
  [ALERT_TYPES.Success]: ICONS.CheckCircle,
  [ALERT_TYPES.Error]: ICONS.ErrorCircle,
  [ALERT_TYPES.Warning]: ICONS.ExclamationTriangle,
  [ALERT_TYPES.Info]: ICONS.InfoCircle,
};

const ALERT_COLORS = {
  [ALERT_TYPES.Success]: '#28a745',   // Green
  [ALERT_TYPES.Error]: '#dc3545',     // Red
  [ALERT_TYPES.Warning]: '#ffc107',   // Yellow
  [ALERT_TYPES.Info]: '#ffffff',      // White
};

// ===============================
// METHODS
// ===============================
function hideAlert() {
  alertStore.hideAlert();
}

</script>